import request from '../utils/request'

export function list(object) {
    return request.post('/my-product-category/list', object)
}

export function allList() {
    return request.post('/my-product-category/all/list')
}

export function queryById(id) {
    return request.get('/my-product-category/'+id)
}
